// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"notifications__gradient-bg5__YI6xM","notifications":"notifications__notifications__q_flJ","notification":"notifications__notification__tZ6Ar"};